import PropTypes from 'prop-types';

export const videoPropType = PropTypes.shape({
  file: PropTypes.shape({
    url: PropTypes.string
  })
});

const imagePropType = PropTypes.shape({
  description: PropTypes.string,
  gatsbyImageData: PropTypes.shape({
    placeholder: PropTypes.shape({
      fallback: PropTypes.string
    }),
    images: PropTypes.shape({
      fallback: PropTypes.shape({
        src: PropTypes.string,
        srcSet: PropTypes.string
      }),
      sources: PropTypes.arrayOf(
        PropTypes.shape({
          srcSet: PropTypes.string
        })
      )
    })
  })
});

export default imagePropType;
